module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Christopher Thomas, Frank D. Macchia\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("John Christopher Thomas ")]), _vm._v("is Clarence J. Abbott Professor of Biblical Studies at Pentecostal Theological Seminary, Cleveland, Tennessee, and director of the Centre for Pentecostal and Charismatic Studies at Bangor University, Bangor, Wales."), _c('BR'), _vm._v("  "), _c('BR'), _c('B', [_vm._v("Frank D. Macchia ")]), _vm._v("is professor of systematic and Pentecostal theology at Vanguard University, Costa Mesa, California, and associate director of the Centre for Pentecostal and Charismatic Studies at Bangor University.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CvxkSG/tc-custom/9781467445498.jpg?1730408764913",
      "alt": "This image is the cover for the book Revelation, Two Horizons New Testament Commentary (THNTC)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Revelation, Two Horizons New Testament Commentary (THNTC)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The book of Revelation is perhaps the most theologically complex and literarily sophisticated — and also the most sensual — document in the New Testament. In this commentary John Christopher Thomas’s literary and exegetical analysis makes the challenging text of Revelation more accessible and easier to understand. Frank Macchia follows up with sustained theological essays on the book’s most significant themes and issues, accenting especially the underappreciated place of the Holy Spirit in the theology of Revelation."), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0